module.exports = __webpack_public_path__ + "static/media/app-image.b975d01b.png";